import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/layouts/default.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/layouts/simple.vue").then(m => m.default || m))
}